import {
  useIsAdminCenterEnabled,
  useIsQuestionsOnlyMode,
  useIsStorylineAdminEnabled,
} from '@ms/yammer-web-ui-features/dist/featureChecks';
import { useMainFeatureSettings } from '@ms/yammer-web-ui-features/dist/featureSettings';
import { useIsMobileClient } from 'hooks/selectors';
import { useIsVivaEngageApp } from 'hooks/useIsVivaEngageApp';
import { useMemo } from 'react';

type UseAppFeatureSettings = () => ReturnType<typeof useMainFeatureSettings>;
export const useAppFeatureSettings: UseAppFeatureSettings = () => {
  const isVivaEngageApp = useIsVivaEngageApp();
  const isAdminCenterEnabled = useIsAdminCenterEnabled();
  const isMobileClient = useIsMobileClient();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();
  const isStorylineAdminEnabled = useIsStorylineAdminEnabled();

  const uiFeatureOptions = useMemo<Parameters<typeof useMainFeatureSettings>[0]>(
    () => ({
      overrides: {
        navigation: {
          admin: isVivaEngageApp && isAdminCenterEnabled,
          collapsiblePanel: isVivaEngageApp && !isQuestionsOnlyMode,
          leftSidebar: !isVivaEngageApp,
          networks: !isMobileClient,
          settings: !isMobileClient,
          storylinesAdmin: isVivaEngageApp && !isQuestionsOnlyMode && !isAdminCenterEnabled && isStorylineAdminEnabled,
        },
        threadPage: {
          groupsExplorerCard: isVivaEngageApp && !isQuestionsOnlyMode,
        },
      },
    }),
    [isAdminCenterEnabled, isMobileClient, isQuestionsOnlyMode, isStorylineAdminEnabled, isVivaEngageApp]
  );

  return useMainFeatureSettings(uiFeatureOptions);
};
